import { AppBar as MUIAppBar, type AppBarProps } from '@mui/material';

export { type AppBarProps } from '@mui/material';

export function AppBar(props: AppBarProps) {
  return <MUIAppBar {...props} />;
}
